<template>
  <fragment>
    <slot
      :userNameTitleAccordingToRole="userNameTitleAccordingToRole"
      :userEmail="userEmail"
      :userProjectTeamRole="userProjectTeamRole">
      <div class="d-flex items-center align-center">
        <v-tooltip bottom>
          <template #activator="{ on }">
            <div>
              <p
                class="medium-p font-weight-medium mb-0 user-info-col"
                v-on="on">
                <span>
                  {{ userNameTitleAccordingToRole }}
                </span>
                <template v-if="userProjectTeamRole">
                  <span class="subtitle-2">{{ userProjectTeamRole }}</span>
                </template>
              </p>
              <p
                class="small-p title-in-modal mb-0">
                {{ userEmail }}
              </p>
            </div>
          </template>
          <span>{{ userNameTitleAccordingToRole }} {{ userProjectTeamRole || '' }}</span>
        </v-tooltip>

        <span
          v-if="!isAccountConfirmed"
          class="ml-4 warning--text fs-12">
          Pending
        </span>
      </div>
    </slot>
  </fragment>
</template>
<script>
import { extractUserTeamRole } from '@/utils';
import { SOURCERY_ASSISTANT_EMAIL } from '@/constants/comments.js';
export default {
  name: 'AppShareModalUserInfo',
  props: {
    userInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isAccountConfirmed() {
      return this.userInfo?.accountConfirmed || this.userEmail === SOURCERY_ASSISTANT_EMAIL;
    },
    userName() {
      return this.userInfo?.name;
    },
    userNameTitleAccordingToRole() {
      const { userProjectTeamRole: role, userName: name } = this;
      if (!role) return name;
      return `${name},`;
    },
    userEmail() {
      return this.userInfo?.email || '---';
    },
    userProjectTeamRole() {
      const { role } = extractUserTeamRole(this.userInfo?.projectTeamRole);
      return role;
    },
  },
};
</script>
<style lang="scss">
.user-info-col {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media (min-width: 721px) {
    max-width: 400px;
  }
  @media (max-width: 720px) {
    max-width: 200px;
  }
}
</style>
